import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import StyledIcon from "../StyledIcon";
import { useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { setNotificationData } from "@app/lib/features/notification/notificationSlice";
import { setModalState } from "@app/lib/features/modalState/modalSlice";
import { RootState } from "@app/lib/store";
import { ROLE } from "@app/components/config";
import dummyImage from "public/background/profile.png";
import { getTimeDifference } from "@app/utils/common";

const NotificationModal = ({ data, onClose, isOpen }: any) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const loginDetails = useSelector((state: RootState) => state.login);
  const notificationTypes = {
    enquiry: "enquiryResponse",
    message: "messagesResponse",
  };
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [currentTab, setCurrentTab] = useState(
    loginDetails?.role !== ROLE.SELLER
      ? notificationTypes.message
      : notificationTypes.enquiry
  );

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      dispatch(setModalState(false));
      onClose();
    }
  };

  useEffect(() => {
    dispatch(setModalState(isOpen));
  }, [isOpen]);

  const handleRedirect = (item: any) => {
    router.push(`/my-messages?id=${item?.propertyId}`);
    dispatch(setNotificationData(item));
    onClose();
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  // //this code disables scroll when modal is open
  // useEffect(() => {
  //   if (isOpen) {
  //     document.body.classList.add("no-scroll");
  //   } else {
  //     document.body.classList.remove("no-scroll");
  //   }

  //   // Cleanup on component unmount
  //   return () => {
  //     document.body.classList.remove("no-scroll");
  //   };
  // }, [isOpen]);

  return (
    <div
      ref={dropdownRef}
      className={`${styles.notificationContainer} shadow-lg`}
    >
      <div className={styles.title}>
        <span>Notifications</span>
        {/* <div
          onClick={() => {
            dispatch(setModalState(false));
            onClose();
          }}
          className="cursor-pointer"
        >
          <StyledIcon icon="cancelIcon" inline={true} />
        </div> */}
      </div>
      {loginDetails?.role === ROLE.SELLER ? (
        <div className="px-5 py-2.5">
          <div className={`${styles.header} grid-cols-2 text-center`}>
            <div
              className={`${styles.tab} px-4 py-1 ${
                currentTab === notificationTypes.enquiry
                  ? styles.activeTab
                  : styles.inactiveTab
              }`}
              onClick={() => setCurrentTab(notificationTypes.enquiry)}
            >
              New Messages
              {data?.[notificationTypes.enquiry]?.length > 0 && (
                <div
                  style={{
                    backgroundColor:
                      currentTab === notificationTypes.enquiry
                        ? "#00333e"
                        : "#cccccc",
                  }}
                  className={styles.count}
                >
                  {data?.[notificationTypes.enquiry]?.length}
                </div>
              )}
            </div>
            <div
              className={`${styles.tab} px-3 py-1 ${
                currentTab === notificationTypes.message
                  ? styles.activeTab
                  : styles.inactiveTab
              }`}
              onClick={() => setCurrentTab(notificationTypes.message)}
            >
              Current Conversations
              {data?.[notificationTypes.message]?.length > 0 && (
                <div
                  style={{
                    backgroundColor:
                      currentTab === notificationTypes.message
                        ? "#00333e"
                        : "#cccccc",
                  }}
                  className={styles.count}
                >
                  {data?.[notificationTypes.message]?.length}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
      <div
        className={`${styles.notificationBody} ${
          loginDetails?.role !== ROLE.SELLER && "mt-3"
        }`}
      >
        {data?.[currentTab]?.length ? (
          data?.[currentTab]?.map((item: any, index: number) => (
            <div
              onClick={() => handleRedirect(item)}
              key={index}
              className={styles.notificationRow}
            >
              <img
                className={`rounded-full blur-xxs ${styles.profileImage}`}
                src={dummyImage?.src}
                alt="profile_img"
              />
              <div className="row">
                <div className={styles.time}>
                  {getTimeDifference(item?.createdAt)}
                </div>
                <div className={styles.name}>
                  {item?.msg?.split("from")?.[1]}
                </div>
                <div className={styles.message}>
                  {item?.message?.slice(0, 80)}
                  {item?.message?.length > 80 && "..."}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className={styles.noMessage}>
            <StyledIcon icon="noFloorPlan" inline={true} />
            <span className={`${styles.noMessageText}`}>
              No New
              {currentTab === notificationTypes.enquiry
                ? "Enquiries"
                : "Conversations"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationModal;
